import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BusinessesOverviewHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="10726" id="faq-hero" className="relative flex min-h-[60vh] w-full items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="h-full w-full bg-background" />
        {}
        <div className="absolute inset-0 bg-background/50 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-transparent to-background" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        {}
        <nav aria-label="Breadcrumb" className="mb-8 flex justify-center items-center gap-2 text-sm font-medium tracking-widest uppercase text-secondary font-sans">
          
          <ChevronRight className="h-3 w-3 text-primary" />
          
        </nav>

        {}
        <h1 className="mx-auto max-w-5xl font-sans font-bold leading-tight text-primary !text-6xl">Custom Watch FAQ</h1>

        {}
        <p className="mx-auto mt-8 max-w-3xl font-sans text-lg text-secondary md:text-xl leading-relaxed">Everything you need to know about starting your own watch brand — MOQ, customization, timelines, and more.and ease.</p>

        {}
        <div className="mt-12 flex flex-col items-center justify-center gap-4">
          <span className="text-xs font-semibold uppercase tracking-widest text-secondary">STILL HAVE QUESTIONS?</span>
          <Button asChild className="group h-auto rounded-md border-2 border-primary bg-primary px-8 py-4 text-base font-semibold text-primary-foreground hover:bg-transparent hover:text-primary transition-all duration-300 shadow-sm hover:shadow-lg hover:-translate-y-1">
            <Link to="/ContactPage">
              Contact Our Team
              <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}